import { SuccessfulApiResponse } from "@eryxcoop/appyx-comm";

export default class SalesByArticleResponse extends SuccessfulApiResponse {
    static defaultResponse() {
        return {
            object: {
                sales_by_article: {
                    rows: [
                        { article: "B1 - Baguette", net_sales: "18500000.00", mix: "42.10", fulfillment: null, projected_fulfillment: null, fulfillment_vs_budget: null, projected_vs_budget: null, net_boxes: "4820.00", boxes_mix: "40.60", boxes_fulfillment: null, boxes_projected_fulfillment: null, boxes_fulfillment_vs_budget: null, boxes_projected_vs_budget: null },
                        { article: "F2 - Focaccia", net_sales: "12300000.00", mix: "28.00", fulfillment: null, projected_fulfillment: null, fulfillment_vs_budget: null, projected_vs_budget: null, net_boxes: "3105.00", boxes_mix: "26.15", boxes_fulfillment: null, boxes_projected_fulfillment: null, boxes_fulfillment_vs_budget: null, boxes_projected_vs_budget: null },
                        { article: "M3 - Medialuna", net_sales: "9200000.00", mix: "20.90", fulfillment: null, projected_fulfillment: null, fulfillment_vs_budget: null, projected_vs_budget: null, net_boxes: "3510.00", boxes_mix: "29.55", boxes_fulfillment: null, boxes_projected_fulfillment: null, boxes_fulfillment_vs_budget: null, boxes_projected_vs_budget: null },
                        { article: "C4 - Croissant", net_sales: "4000000.00", mix: "9.00", fulfillment: null, projected_fulfillment: null, fulfillment_vs_budget: null, projected_vs_budget: null, net_boxes: "440.00", boxes_mix: "3.70", boxes_fulfillment: null, boxes_projected_fulfillment: null, boxes_fulfillment_vs_budget: null, boxes_projected_vs_budget: null },
                    ],
                    total: { article: null, net_sales: "44000000.00", mix: "100.00", fulfillment: "82.40", projected_fulfillment: "104.30", fulfillment_vs_budget: "-17.60", projected_vs_budget: "4.30", net_boxes: "11875.00", boxes_mix: "100.00", boxes_fulfillment: "78.30", boxes_projected_fulfillment: "98.10", boxes_fulfillment_vs_budget: "-21.70", boxes_projected_vs_budget: "-1.90" },
                },
            },
            errors: [],
        };
    }

    salesByArticle() {
        const salesByArticle = this.content().sales_by_article;
        return {
            rows: salesByArticle.rows.map((row) => this._adaptRow(row)),
            total: this._adaptRow(salesByArticle.total),
        };
    }

    _adaptRow(row) {
        return {
            group: row.article,
            netSales: this._toNumber(row.net_sales),
            mix: this._toNumber(row.mix),
            fulfillment: this._toNumber(row.fulfillment),
            projectedFulfillment: this._toNumber(row.projected_fulfillment),
            fulfillmentVsBudget: this._toNumber(row.fulfillment_vs_budget),
            projectedVsBudget: this._toNumber(row.projected_vs_budget),
            netBoxes: this._toNumber(row.net_boxes),
            boxesMix: this._toNumber(row.boxes_mix),
            boxesFulfillment: this._toNumber(row.boxes_fulfillment),
            boxesProjectedFulfillment: this._toNumber(row.boxes_projected_fulfillment),
            boxesFulfillmentVsBudget: this._toNumber(row.boxes_fulfillment_vs_budget),
            boxesProjectedVsBudget: this._toNumber(row.boxes_projected_vs_budget),
        };
    }

    _toNumber(value) {
        return value == null ? null : Number(value);
    }
}
